import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRef } from "react";

const PcContainer1 = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 980px;
  background-image: url("/img/main.png");
  background-size: cover;
  background-position: center center;
  /* background: linear-gradient(180deg, #3ac887 0%, #ffffff 85%); */
`;

const PcContent1 = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 980px;
  position: relative;
`;

const PcContent1Logo = styled.img`
  width: 253px;
  position: absolute;
  left: 105px;
  top: 505px;
`;

const PcContent1Title = styled.div`
  color: white;
  font-size: 45px;
  font-weight: 600;
  position: absolute;
  left: 105px;
  top: 600px;
  line-height: 65px;
`;

const PcContent1Apple = styled.img`
  position: absolute;
  width: 172px;
  left: 105px;
  top: 758px;
`;

const PcContent1Android = styled.img`
  position: absolute;
  width: 197px;
  left: 298px;
  top: 758px;
`;

const PcContainer2 = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 980px;
`;

const PcContent2 = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 980px;
  background-image: url("/img/2bg.png");
  background-size: cover;
`;

const PcContainer3 = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 980px;
  background-color: rgba(58, 200, 135, 0.08);
`;

const PcContent3 = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 980px;
  background-image: url("/img/3bg.png");
  background-size: cover;
`;

const PcContainer4 = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 980px;
`;

const PcContent4 = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 980px;
  background-image: url("/img/4bg.png");
  background-size: cover;
`;

const PcContainer5 = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 980px;
`;

const PcContent5 = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 980px;
  background-image: url("/img/5bg.png");
  background-size: cover;
`;

const PcContainer6 = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 980px;
`;

const PcContent6 = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 980px;
  background-image: url("/img/6bg.png");
  background-size: cover;
`;

const PcContainer7 = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 980px;
  background-color: rgba(58, 200, 135, 0.08);
`;

const PcContent7 = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 980px;
  position: relative;
`;

const PcContent7Img = styled.img`
  width: 574.63px;
  position: absolute;
  top: 170px;
  right: 139.37px;
`;

const PcContent7Title = styled.div`
  font-weight: 600;
  font-size: 34px;
  position: absolute;
  top: 321px;
  left: 140px;
  line-height: 52px;
`;

const PcContent7Android = styled.img`
  width: 135px;
  position: absolute;
  top: 463px;
  left: 140px;
`;

const PcContent7Apple = styled.img`
  width: 135px;
  position: absolute;
  top: 523px;
  left: 140px;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: white;
`;

const FooterContent = styled.div`
  width: 1400px;
  min-width: 1400px;
  padding: 40px 0 28px 105px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Company = styled.div`
  color: #5a5a5a;
  font-weight: 600;
`;

const CompanyLine = styled.div`
  width: 100%;
  height: 1px;
  background: #cfcfcf;
`;

const CompanyDes = styled.div`
  line-height: 32px;
  color: #888888;

  overflow: hidden;
  max-height: ${(props) => (props.$open ? "500px" : "0px")};
  transition: max-height 220ms ease;
`;

const CompanyNotice = styled.div`
  color: #888888;
  font-size: 12px;
  line-height: 18px;
`;

const CompanyPolicy = styled.div`
  font-weight: 600;
  color: #888888;
  cursor: pointer;
`;

const CompanyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CompanyToggle = styled.div`
  font-size: 13px;
  color: #888888;
  cursor: pointer;
  user-select: none;
`;

const PcHome = () => {
  const navigate = useNavigate();
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  const footerBottomRef = useRef(null);
  return (
    <>
      <PcContainer1>
        <PcContent1>
          <PcContent1Title>
            우리 동네 이웃 월리,
            <br />내 반려동물의 친구가 되다.
          </PcContent1Title>
          <PcContent1Logo src="/img/LogoWhite.png" />
          <a href="https://apps.apple.com/app/id6741297868">
            <PcContent1Apple src="img/apple.png" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.flynnapps.wally">
            <PcContent1Android src="img/android.png" />
          </a>
        </PcContent1>
      </PcContainer1>
      <PcContainer2>
        <PcContent2></PcContent2>
      </PcContainer2>
      <PcContainer3>
        <PcContent3></PcContent3>
      </PcContainer3>
      <PcContainer4>
        <PcContent4></PcContent4>
      </PcContainer4>
      <PcContainer5>
        <PcContent5></PcContent5>
      </PcContainer5>
      <PcContainer6>
        <PcContent6></PcContent6>
      </PcContainer6>
      <PcContainer7>
        <PcContent7>
          <PcContent7Title>
            믿을 수 있는 이웃, <span style={{ color: "#50B385" }}>월리</span>
            에게
            <br />
            반려동물을 맡겨보세요!
          </PcContent7Title>
          <PcContent7Img src="/img/mockup.png" />
          <a href="https://play.google.com/store/apps/details?id=com.flynnapps.wally">
            <PcContent7Android src="/img/android.png" />
          </a>
          <a href="https://apps.apple.com/app/id6741297868">
            <PcContent7Apple src="/img/apple.png" />
          </a>
        </PcContent7>
      </PcContainer7>
      <FooterContainer>
        <FooterContent>
          <CompanyRow>
            <Company>(주)월리</Company>
            <CompanyToggle
              onClick={() => {
                setIsCompanyOpen((prev) => {
                  const next = !prev;

                  // 🔽 펼쳐질 때만 스크롤
                  if (!prev) {
                    setTimeout(() => {
                      footerBottomRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "end",
                      });
                    }, 250); // 애니메이션 끝난 뒤
                  }

                  return next;
                });
              }}
            >
              {isCompanyOpen ? "▲" : "▼"}
            </CompanyToggle>
          </CompanyRow>
          <CompanyLine />
          <CompanyDes $open={isCompanyOpen}>
            부산광역시 기장군 기장읍 기장대로 82-8 <br />
            사업자 등록번호: 323-88-03325 | 대표: 이승철 | 통신판매신고번호:
            2025-부산기장-0252 | 대표번호: 010-6290-2786 | 문의메일:
            admin@wallykorea.com
          </CompanyDes>
          <CompanyNotice>(주)월리는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.  따라서 (주)월리는 서비스 거래 정보 및 거래에 책임을 지지 않습니다.</CompanyNotice>
          <CompanyPolicy onClick={() => navigate("policy")}>
            개인정보처리방침
          </CompanyPolicy>
          <div ref={footerBottomRef} />
        </FooterContent>
      </FooterContainer>
    </>
  );
};

export default PcHome;
